import { Injectable, inject } from '@angular/core';

import { I18nService } from '@ts/shared/i18n/util-core';
import {
  ShippingMethod,
  ShippingMethodCode,
  ShippingMethodTag,
} from '@ts/shipping/shared/util-core';

import { ShippingMethodI18n, ShippingMethodTagI18n } from './shipping.model';

@Injectable({
  providedIn: 'root',
})
export class ShippingI18nService {
  private i18nService = inject(I18nService);

  SHIPPING_METHOD_TAGS: {
    [code in ShippingMethodCode]: readonly ShippingMethodTag[];
  } = {
    'biteship:grab:instant': ['time-instant'],
    'biteship:grab:instant_car': ['time-instant'],
    'biteship:lalamove:mpv': ['time-instant'],
    'biteship:lalamove:truck': ['time-instant'],
    'biteship:lalamove:van': ['time-instant'],
    'point-of-sales': [],
    'self-pickup': [],
  };

  methodTranslate$(
    shippingMethod: ShippingMethod,
  ): Promise<ShippingMethodI18n> {
    return this.i18nService.translateObject$<ShippingMethodI18n>(
      `shipping.method.code.${shippingMethod.code}`,
      {
        name: true,
        description: true,
      },
    );
  }

  async methodTagsTranslate$(
    shippingMethod: ShippingMethod,
  ): Promise<readonly ShippingMethodTagI18n[]> {
    const tagsI18n: ShippingMethodTagI18n[] = [];
    for (const shippingMethodTag of this.SHIPPING_METHOD_TAGS[
      shippingMethod.code
    ]) {
      tagsI18n.push(
        await this.i18nService.translateObject$<ShippingMethodTagI18n>(
          `shipping.method.tag.${shippingMethodTag}`,
          {
            description: true,
          },
        ),
      );
    }
    return tagsI18n;
  }
}
